var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_22629)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#00C451"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 19.7437C30 25.1237 25.6043 29.4858 20.1813 29.4858C18.4599 29.4858 16.8427 29.0455 15.4352 28.2735L10 30L11.7721 24.7734C10.8777 23.3046 10.3633 21.5832 10.3633 19.7424C10.3633 14.3621 14.759 10 20.1812 10C25.6043 10.0001 30 14.3621 30 19.7437ZM20.1813 11.5521C15.6292 11.5521 11.9271 15.2266 11.9271 19.7437C11.9271 21.535 12.5118 23.1952 13.4993 24.5455L12.4688 27.5872L15.641 26.5781C16.9442 27.4336 18.5055 27.9335 20.1813 27.9335C24.7332 27.9335 28.4363 24.2591 28.4363 19.7424C28.4363 15.2267 24.7332 11.5521 20.1813 11.5521ZM25.1395 21.9869C25.0782 21.8867 24.918 21.8267 24.6784 21.7082C24.4376 21.5885 23.254 21.0103 23.034 20.9309C22.8126 20.8514 22.6525 20.8111 22.491 21.0506C22.3308 21.2902 21.87 21.8266 21.7293 21.9868C21.5887 22.1457 21.4494 22.1653 21.2085 22.0467C20.9676 21.927 20.1916 21.6743 19.2723 20.8605C18.5575 20.2281 18.0744 19.4468 17.9338 19.2085C17.7932 18.969 17.9195 18.84 18.0393 18.7203C18.1473 18.6135 18.2802 18.4416 18.3999 18.3023C18.5211 18.163 18.5614 18.064 18.6408 17.9039C18.7215 17.745 18.6812 17.6056 18.6212 17.4859C18.5613 17.3661 18.0796 16.1916 17.879 15.7137C17.6785 15.2358 17.478 15.3153 17.3373 15.3153C17.1967 15.3153 17.0365 15.2944 16.8764 15.2944C16.715 15.2944 16.4546 15.3543 16.2345 15.5939C16.0131 15.8322 15.3925 16.4104 15.3925 17.5848C15.3925 18.7607 16.2541 19.896 16.3751 20.0549C16.4949 20.2138 18.0392 22.7031 20.4857 23.6601C22.9335 24.6159 22.9335 24.2969 23.3736 24.2566C23.815 24.2175 24.7981 23.6797 24.9987 23.1224C25.1993 22.5637 25.1993 22.0859 25.1395 21.9869Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_22629"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp2);
export default __webpack_public_path__ + "static/media/whatsapp-2.18ebc38002d975294d57874e344a1223.svg";
export { ForwardRef as ReactComponent };